export const amountStringToNumber = val => {
  const parenthesisMultiplier = val.includes('(') ? -1 : 1;
  return parseFloat(val.replace(/[^0-9.-]+/g, '')) * parenthesisMultiplier;
};

export const prependCurrencySymbol = str => `$${str}`;
